import * as storage from '../../util/storage';

export default class Auth {
  static isLogged() {
    const accessToken = localStorage.getItem(storage.KEY_ACCESS_TOKEN);
    return !!accessToken;
  }

  static signIn(token) {
    localStorage.setItem(storage.KEY_ACCESS_TOKEN, token.access_token);
    localStorage.setItem(storage.KEY_REFRESH_TOKEN, token.refresh_token);
  }

  static signOut() {
    localStorage.clear();
    location.reload();
  }
}


// WEBPACK FOOTER //
// ./src/service/auth/auth.js